import env from '../../env';
import { AppClientId } from '../Shared/constants';
import * as installationConstants1 from './installations/1/constants';
import * as installationConstants2 from './installations/2/constants';
import * as installationConstants3 from './installations/3/constants';
import * as installationConstants4 from './installations/4/constants';
import * as installationConstants6 from './installations/6/constants';
import * as installationConstants7 from './installations/7/constants';
import * as installationConstants8 from './installations/8/constants';
let installationConstants;
switch (env.clientId) {
  case AppClientId.INDEWAL:
    installationConstants = installationConstants1;
    break;
  case AppClientId.IDWLEASE:
    installationConstants = installationConstants1;
    break;
  case AppClientId.HARRY_NIJBOER:
    installationConstants = installationConstants2;
    break;
  case AppClientId.HOOIKAMMER:
    installationConstants = installationConstants3;
    break;
  case AppClientId.IDW_GMBH:
    installationConstants = installationConstants4;
    break;
  case AppClientId.AUTOWIENTJES:
    installationConstants = installationConstants6;
    break;
  case AppClientId.AUTOHUISSALLAND:
    installationConstants = installationConstants7;
    break;
  case AppClientId.HILTERMANN:
    installationConstants = installationConstants8;
    break;
  default:
    installationConstants = installationConstants1;
}

export const VEHICLE_DOCUMENT_NAMES = installationConstants.VEHICLE_DOCUMENT_NAMES;
export const WEBLOGIN_VEHICLE_DOCUMENT_NAMES_CREDITOR = [
  'hemex_inspection',
  'tdn',
  'other',
  'invoice_purchase',
  // 'release_report',
  // 'rental_statement',
  // 'rdw_vehicle_report',
  // 'tuv_vehicle_report',
  // 'report_accept_bedrijfsvoorraad',
];

export const WEBLOGIN_VEHICLE_DOCUMENT_NAMES_DEBITOR = [
  // 'cmr_export_goederen_ontvangen',
  // 'verklaring_nieuw_en_ongebruikt',
  // 'permanent_registration',
  // 'order_confirmation',
  // 'tdn',
  'other',
];

export const WEBLOGIN_VEHICLE_DOCUMENT_NAMES_DEBITOR_UPLOADABLE = ['other', 'tdn'];

export const WEBLOGIN_VEHICLE_DOCUMENT_NAMES_CREDITOR_UPLOADABLE = ['other'];

export const COMPANY_DOCUMENT_NAMES = installationConstants.COMPANY_DOCUMENT_NAMES;
export const USER_DOCUMENT_NAMES = installationConstants.USER_DOCUMENT_NAMES;
